import * as React from "react";

import { cn } from "../lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "tw-figr-ring-offset-background focus-visible:tw-figr-ring-2 focus-visible:tw-figr-ring-primary focus-visible:tw-figr-ring-offset-2 focus-visible:tw-figr-ring-offset-primary tw-figr-border-neutral-200 file:tw-figr-border-0 tw-figr-bg-base-white file:tw-figr-bg-transparent tw-figr-text-desktop-caption-regular tw-figr-text-base-black file:tw-figr-text-desktop-caption-regular placeholder:tw-figr-text-neutral-700 tw-figr-h-10 tw-figr-w-full tw-figr-rounded-m tw-figr-border focus-visible:tw-figr-outline-none disabled:tw-figr-cursor-not-allowed disabled:tw-figr-opacity-50 tw-figr-flex tw-figr-px-3 tw-figr-py-2 file:tw-figr-font-medium",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
